import { Reveal } from "./Reveal";
import { PrimaryBtn, GhostBtn } from "./ui";
import { waLink } from "../data/site";

export const CTABand = ({ title = "Have a Similar Requirement?", text }) => (
  <section className="border-t border-seam bg-iron" data-testid="cta-band">
    <div className="noise relative mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-spark">RFQ · Saudi Arabia</p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-frost sm:text-5xl">
          {title}
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-cadmium sm:text-lg">
          {text ||
            "Send us your drawings, photos or equipment details. Our team will assess your requirement and recommend the appropriate solution."}
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <PrimaryBtn to="/rfq" testid="ctaband-rfq-btn">Request a Quote</PrimaryBtn>
          <GhostBtn href={waLink()} testid="ctaband-whatsapp-btn">WhatsApp an Engineer</GhostBtn>
        </div>
      </Reveal>
    </div>
  </section>
);
